export default {
    getDataTableOptions: state => state.dataTableOptions,

    isCountryGridOpen: state => state.countryGridIsOpen,
    isCountryFormOpen: state => state.countryFormIsOpen,
    getCountrySearchFields: state => state.countrySearchFields,
    getCountryHeaderFields: state => state.countryHeaderFields,
    getCountryFormActions: state => state.countryFormActions,
    getCountryActions: state => state.countryActions,
    getCountryRowActions: state => state.countryRowActions,

    isCountyGridOpen: state => state.countyGridIsOpen,
    isCountyFormOpen: state => state.countyFormIsOpen,
    getCountySearchFields: state => state.countySearchFields,
    getCountyHeaderFields: state => state.countyHeaderFields,
    getCountyFormActions: state => state.countyFormActions,
    getCountyActions: state => state.countyActions,
    getCountyRowActions: state => state.countyRowActions,

    isCityGridOpen: state => state.cityGridIsOpen,
    isCityFormOpen: state => state.cityFormIsOpen,
    getCitySearchFields: state => state.citySearchFields,
    getCityHeaderFields: state => state.cityHeaderFields,
    getCityFormActions: state => state.cityFormActions,
    getCityActions: state => state.cityActions,
    getCityRowActions: state => state.cityRowActions,


}